import { createSlice } from '@reduxjs/toolkit';




const initialState = {
  products:[]
};
export const  productsDetailById =(id)=>{
  // let product = initialState.products.find((item)=>item.id+""===id+"")
  // return product
}

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, { payload }) => {
     
      state.products = [...payload];
    },
    
    
   
    clearProductsState: (state) => {
      state=initialState
    }
  }
});

export const { setProducts, clearProductsState } = productsSlice.actions;

export const productsData = (state) => state.products;


export default productsSlice.reducer;
